import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import "../Delivery.css";
import Modal from "@mui/material/Modal";
import {
  CmpButton,
  CmpTextField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";

const DeliveryDetailModal = ({
  xOpen = false,
  fCloseDeliveryDetailModal,
  xTitle = "",
  data = {},
  Customer = "",
  VocNo = "",
  fConfirmQty,
  setDeliverItemList
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
const [sBtnDisable,setBtnDisable]=useState(false);
  return (
    <Modal
      open={xOpen}
      onClose={fCloseDeliveryDetailModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-Delivery-search"
      >
        <GCTitleSticky title={xTitle} onClose={fCloseDeliveryDetailModal} />
        <div className="p-2">
          <Grid
            container
            spacing={1}
            columns={{ xs: 4, sm: 4, md: 4 }}
            className="mt-2 justify-content-between"
          >
            <Grid item lg={2} md={4} xs={6}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Voc.No : " + VocNo}
              />
            </Grid>

            <Grid item lg={2} md={4} xs={6}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"ItmCd : " + data.ItmCd}
              />
            </Grid>

            <Grid item lg={2} md={4} xs={6}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"ItmName : " + data.ItmName}
              />
            </Grid>

            <Grid item lg={2} md={4} xs={6}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Qty : " + data.Qty}
              />
            </Grid>
            <Grid item lg={2} md={4} xs={6} className="Scancode">
              <CmpTypographyField xcomponent={"span"} xText={"ConfirmQty : "} />

              <CmpTextField
                //   xLabelText={"ScanCode"}
                xVariant={"standard"}
                xValue={data.ConfirmQty}
                xOnChange={fConfirmQty}
                xReadOnly={false}
                xType={"text"}
                xName={"ConfirmQty"}
                xonFocus={()=>{
                  setBtnDisable(true)
                }}
                xonBlur={()=>{
                  setBtnDisable(false)
                }}
              />
            </Grid>
            <Grid item  md={12} xs={6} textAlign={"center"} > 

              <CmpButton
                xbtnName="Save"
                xOnClick={()=>{ 
                  setDeliverItemList(prevList =>
                    prevList.map(item => (item.id === data.id ? data : item))
                  );
                  fCloseDeliveryDetailModal()
                }}
                xVariant="contained"
                xDisabled={sBtnDisable}
                xSize="small"
              />
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default DeliveryDetailModal;
